import React, { useEffect } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SEO from '../SEO/SEO';
import Header from '../HeaderComponent/header';
import Footer from '../FooterComponent/footer';
import Intro from './Introcomponent/Intro';
import AboutComponent from './Aboutcomponent/aboutcomponent';
import EyeConditions from './EyeConditions/EyeConditions';
import Doctors from './Doctors/Doctors';
import Achievements from './Achivements/Achievements';
import Cta from './Ctacomponent/Cta';

import './HomePage.css';

function HomePage() {
  useEffect(() => {
    // Section heights depend on 100vh (the hero is capped to one screen), so
    // the pinned ScrollTriggers created in each child's useLayoutEffect can be
    // built against a layout that has not settled yet — which left About
    // pinned at scroll 0 on some viewport sizes (e.g. 1905x945). Two frames
    // after mount the layout is final, so re-measure once. At mount scrollY
    // is 0, so this cannot move the page.
    let inner = 0;
    const outer = requestAnimationFrame(() => {
      inner = requestAnimationFrame(() => ScrollTrigger.refresh());
    });

    return () => {
      cancelAnimationFrame(outer);
      cancelAnimationFrame(inner);
    };
  }, []);

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    return () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    };
  }, []);


  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "Dr. GR Reddy Eye Hospital",
    "alternateName": ["GR Reddy Eye Hospital", "Dr GR Reddy Eye Hospital Tadepalligudem"],
    "url": "https://www.drgrreddy.com/",
    "logo": "https://www.drgrreddy.com/favicon.png",
    "image": "https://www.drgrreddy.com/favicon.png",
    "description": "Leading eye hospital in Tadepalligudem, West Godavari. Dr. GR Reddy Eye Hospital offers advanced cataract surgery, vitreo-retina care, glaucoma treatment, refractive surgery, and comprehensive eye checkups.",
    "telephone": "+91-9701434106",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Opp. Bus Depot, Ambedkar Nagar",
      "addressLocality": "Tadepalligudem",
      "addressRegion": "Andhra Pradesh",
      "postalCode": "534101",
      "addressCountry": "IN"
    },
    "medicalSpecialty": [
      "Ophthalmology",
      "Eye Surgery",
      "Cataract Surgery",
      "Vitreo-Retinal Surgery",
      "Glaucoma Treatment",
      "Paediatric Ophthalmology"
    ],
    "sameAs": [
      "https://www.instagram.com/grreddyeye_hospital/?hl=en",
      "https://www.youtube.com/@drgrreddyeyehospital9390"
    ]
  };

  const homeKeywords = [
    "Best Eye Hospital in Tadepalligudem",
    "Best Eye Hospital Tadepalligudem",
    "Best Eye Doctor in Tadepalligudem",
    "Best Ophthalmologist in Tadepalligudem",
    "Best Eye Specialist in Tadepalligudem",
    "Best Eye Surgeon in Tadepalligudem",
    "Top Eye Hospital in Tadepalligudem",
    "Top Eye Doctor in Tadepalligudem",
    "Top Ophthalmologist in Tadepalligudem",
    "Leading Eye Hospital in Tadepalligudem",
    "Trusted Eye Hospital in Tadepalligudem",
    "Reputed Eye Hospital in Tadepalligudem",
    "Experienced Eye Doctor in Tadepalligudem",
    "Advanced Eye Hospital in Tadepalligudem",
    "Advanced Eye Care in Tadepalligudem",
    "Modern Eye Hospital in Tadepalligudem",
    "Complete Eye Care Hospital Tadepalligudem",
    "Multi Specialty Eye Hospital Tadepalligudem",
    "Specialized Eye Hospital Tadepalligudem",
    "Quality Eye Care Tadepalligudem",
    "Eye Hospital in Tadepalligudem",
    "Eye Clinic in Tadepalligudem",
    "Eye Care Hospital Tadepalligudem",
    "Eye Doctor Tadepalligudem",
    "Eye Specialist Tadepalligudem",
    "Ophthalmologist Tadepalligudem",
    "Eye Surgeon Tadepalligudem",
    "Eye Treatment Tadepalligudem",
    "Eye Surgery Tadepalligudem",
    "Eye Checkup Tadepalligudem",
    "Vision Care Tadepalligudem",
    "Best Eye Hospital Near Me",
    "Best Eye Doctor Near Me",
    "Best Ophthalmologist Near Me",
    "Eye Hospital Near Me",
    "Eye Doctor Near Me",
    "Eye Specialist Near Me",
    "Eye Clinic Near Me",
    "Eye Emergency Hospital Near Me",
    "GR Reddy Eye Hospital",
    "GR Reddy Eye Hospital Tadepalligudem",
    "Dr GR Reddy Eye Hospital",
    "Dr GR Reddy Tadepalligudem",
    "GR Reddy Hospital Tadepalligudem",
    "Best Eye Hospital in West Godavari",
    "Best Eye Doctor in West Godavari",
    "Eye Hospital West Godavari",
    "Book Eye Doctor Appointment Tadepalligudem"
  ];

  return (
    <div className="HomePage">
      <SEO
        title="GR Reddy Eye Hospital | Best Eye Hospital in Tadepalligudem"
        description="Dr. GR Reddy Eye Hospital is the leading eye hospital in Tadepalligudem, West Godavari. Specialist care in cataract surgery, vitreo-retina, glaucoma, and paediatric eye care."
        keywords={homeKeywords}
        canonical="https://www.drgrreddy.com/"
        ogImage="https://www.drgrreddy.com/favicon.png"
        schemaData={homeSchema}
      />
      <Header />
      <main className="main-content">
        <Intro />
        <AboutComponent />
        <EyeConditions />
        <Doctors />
        <Achievements />
        <Cta />
      </main>
      <Footer />
    </div>
  );
}

export default HomePage;

